import React, { useContext } from "react";
import { REPORT_EXPORTS } from "@sscs/types";
import { ExportButton } from "../../../common";
import { ReportContext } from "../../../context";
/**
 * The role-gated CycloneDX / SPDX export buttons shared by every xBOM page.
 * Pass to a `Page.Header`'s `actions` slot.
 */
const XbomExportActions = ({ disableSpdx = false, }) => {
    const { roles, activeExport, onReportExport } = useContext(ReportContext);
    return (React.createElement(React.Fragment, null,
        roles.canExportCycloneDx && (React.createElement(ExportButton, { id: "export-as-cyclonedx", text: `Export as ${REPORT_EXPORTS.cycloneDX}`, onClick: () => onReportExport === null || onReportExport === void 0 ? void 0 : onReportExport("cycloneDX"), isDisabled: activeExport.cycloneDX })),
        roles.canExportSpdx && !disableSpdx && (React.createElement(ExportButton, { id: "export-as-spdx", text: `Export as ${REPORT_EXPORTS.spdx}`, onClick: () => onReportExport === null || onReportExport === void 0 ? void 0 : onReportExport("spdx"), isDisabled: activeExport.spdx }))));
};
export default XbomExportActions;
//# sourceMappingURL=XbomExportActions.js.map